module.exports = __webpack_public_path__ + "img/warning.78fa9a58.svg";